import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import tw from "tailwind-styled-components";
import { getNewsList } from "@redux/news/actions";
import { Text } from "@components";
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import quote from "@assets/images/quote.png"
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./style.css"

import { Carousel } from "react-responsive-carousel";



export const Reviews = ({ item }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { newsList } = useSelector((store) => store.newsReducer);
    const topNews = [...newsList?.slice(0, 3), ...newsList?.slice(0, 3)];
    const [isXL, setIsXL] = useState(window.innerWidth >= 768);
    const [selectedIndex, setSelectedIndex] = useState(0);

    const updateMedia = () => {
        setIsXL(window.innerWidth >= 768);
        if (window.innerWidth >= 768 && window.innerWidth < 850) {
            setSelectedIndex(0);
        }
    };

    useEffect(() => {
        window.addEventListener('resize', updateMedia);
        return () => window.removeEventListener('resize', updateMedia);
    }, []);


    useEffect(() => {
        dispatch(getNewsList());
    }, []);

    const customArrow = (onClickHandler, hasPrevOrNext, label, isLeftArrow) => {
        return (
            <button
                type="button"
                onClick={onClickHandler}
                className={`z-[100] border-solid border-[1px]  h-10 w-10 absolute bottom-0 top-[95%] transform -translate-y-1/2 p-2 rounded-full ${hasPrevOrNext && !(isXL ? topNews?.length <= 2 : topNews?.length <= 1) ? "border-black" : "border-gray-400"} ${isLeftArrow ? 'right-[70px]' : 'right-4'}`}
                aria-label={label}
                disabled={!hasPrevOrNext || (isXL ? topNews?.length <= 2 : topNews?.length <= 1)}
            >
                {isLeftArrow ? <ArrowBackIosRoundedIcon color={hasPrevOrNext && !(isXL ? topNews?.length <= 2 : topNews?.length <= 1) ? "black" : "disabled"} fontSize="small" /> : <ArrowForwardIosRoundedIcon color={hasPrevOrNext && !(isXL ? topNews?.length <= 2 : topNews?.length <= 1) ? "black" : "disabled"} fontSize="small" />}
            </button>
        );
    };

    return (
        <Container>
            <div className={`flex flex-col items-center justify-center`}>
                {topNews?.length > 0 && (
                    <Text className="text-md text-[#004996] flex">{"Opinions"}</Text>
                )}
                {topNews?.length > 0 && (
                    <Text className="text-[26px] font-semibold flex">
                        {"Latest Reviews"}
                    </Text>
                )}
                <div className="w-full mt-14 h-auto flex flex-wrap items-center justify-center max-w-[1140px]">
                    <Carousel className=" w-full carousel-container" centerMode axis="horizontal" width={"100%"} emulateTouch
                        centerSlidePercentage={(isXL && (topNews?.length > 1)) ? 50 : 100} showIndicators={false} showStatus={false} showThumbs={false} swipeable
                        renderArrowPrev={(onClickHandler, hasPrev, label) =>
                            customArrow(onClickHandler, hasPrev, label, true)
                        }
                        renderArrowNext={(onClickHandler, hasNext, label) =>
                            customArrow(onClickHandler, hasNext, label, false)
                        }
                        onChange={(index) => setSelectedIndex(index)}
                        selectedItem={selectedIndex}
                    >
                        {topNews &&
                            [...topNews]?.map((client, index) => {
                                const logo = client?.attributes?.logo?.data?.attributes?.url;
                                const image =
                                    client?.attributes?.backgroundImage?.data?.attributes?.url;
                                return (
                                    <CarouselItem
                                        onClick={() => { }}
                                        style={{ backgroundPosition: "center" }}
                                    >
                                        <div className="w-full h-full p-3 sm:p-5 flex absolute flex-col gap-y-3 sm:gap-y-5">
                                            <div className=" h-[200px] sm:h-[100px] flex flex-col sm:flex-row gap-x-5 " style={{ background: `url(${quote})`, backgroundSize: "65px 65px", backgroundRepeat: "no-repeat", backgroundPositionX: "right", backgroundPositionY: "top" }}>
                                                <div className=" w-[100px] min-w-[100px] min-h-[100px] rounded-xl h-[100px]">
                                                    <img
                                                        src={logo}
                                                        alt="logo"
                                                        className="w-full h-full"
                                                    />
                                                </div>
                                                <div style={{ display: "flex", justifyContent: "space-between", height: "100%", flexDirection: "column", alignItems: "start", minHeight: "100px" }}>
                                                    <Text className="text-gray-700 text-[14px] font-bold">
                                                        {"garry25"}
                                                    </Text>
                                                    <Text className="text-[#000000] text-[18px] font-black w-auto overflow-hidden line-clamp-1">
                                                        {client?.attributes?.title}
                                                    </Text>
                                                    <Text className="text-[#000000] text-[14px] bg-[#f8bc04] rounded-2xl p-1 px-2">
                                                        {"rating 4.0"}
                                                    </Text>
                                                </div>
                                            </div>
                                            <div className="h-full w-full my-2"  >
                                                <Text className="text-start text-[#494949] font-normal overflow-hidden noWrap text-[14px] line-clamp-[4] sm:line-clamp-[6] md:line-clamp-[9]">
                                                    I recently had the chance to play the nine-hole course in Lossiemouth, and after two days in a row there, I can confidently say it's the best course of its size I've ever experienced. The holes themselves are truly interesting and offer a good challenge.  Adding to the positive experience, the couple who own the course are very nice people.  One particularly memorable moment was when a (presumably) errant helicopter shot past the course –  certainly an experience I won't soon forget! If you're ever in Lossiemouth, I highly recommend checking out this fantastic nine-hole course. You won't be disappointed.
                                                </Text>
                                            </div>
                                        </div>
                                    </CarouselItem>
                                );
                            })}
                    </Carousel>
                </div>

            </div>
        </Container>
    );
};

const Container = tw.div`
lg:px-[8%]  
px-[4%] 
lg:py-14 
py-8 
bg-[#f5f5f5]
`;

const CarouselItem = tw.div`
m-4
mb-14
rounded-lg
w-[90%]
md:h-[360px]
sm:h-[300px]
h-[320px]
object-cover
shadow
drop-shadow-xl
hover:shadow-[0px_0px_20px_0px_#cdcaec] 
bg-[#ffffff]
`;
